/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, Table } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { openDSWindow } from '../../../../helpers/Window';
import ModalContent, { MeasureModalHeader } from '../../../../components/MeassureModalContent';
import { filterData, getColumns, renderStatus, renderObjective } from './helper';
import { getLocales } from '../../../../components/Table/newTable';

const TableC = ({
  data = {},
  sections = {},
  options = {},
  t = (s) => s,
  sidebarCollapsed = false,
  locationId = '',
  mod = '',
  mode,
  sourceId,
  isOwnData = false,
}) => {
  const [expanded, setExpanded] = useState([]);
  const [maxWidth, setMaxWidth] = useState('100%');
  const [activeModal, setActiveModal] = useState(false);

  const getLink = (url = '') => {
    if (isOwnData) {
      return url;
    }

    if (sourceId) {
      return `${url}?sourceId=${sourceId}`;
    }
  }

  useEffect(() => {
    setMaxWidth((prev) => prev === '100%' ? '99.9%' : '100%');
  }, [sidebarCollapsed]);

  const toggle = useCallback((key) => setExpanded((prev) => [...prev, key]), []);
  const unToggle = useCallback((key) => setExpanded((prev) => [...prev.filter((p) => p !== key)]), []);

  const columns = useMemo(() =>
    getColumns({
      t,
      maxWidth,
      modalActions: (val) => setActiveModal(val),
      toggle,
      unToggle,
      expanded,
    }), [t, maxWidth, expanded]);

  const dataSource = useMemo(() =>
    filterData({
      data,
      sections,
      options,
    }), [data, sections, options]);

  const toggleExpand = useCallback((expanded, { key }) =>
    expanded ? toggle(key) : unToggle(key), [toggle, unToggle]);

  const expandable = useMemo(() => ({
    rowExpandable: (item) => (item.children && item.children.length) ? true : false,
    expandedRowKeys: expanded,
    columnWidth: '2%',
    expandedRowClassName: () => 'expanded-table-cell',
    onExpand: toggleExpand,
  }), [expanded]);

  return (
    <>
      <Modal
        open={typeof activeModal === 'object'}
        className="rec-modal"
        title={(
          <MeasureModalHeader
            t={t}
            rec={activeModal}
            layout="LAYOUT_B"
            informationSource={activeModal ? activeModal.proponents[0] : null}
          />
        )}
        destroyOnClose
        footer={[
          <>
            {mode === 'proxy' ? (
              <Button
                type="primary"
                onClick={() => {
                  openDSWindow({
                    url: `/proxy/${mod}/view/scl/${locationId}/risk/${activeModal.riskTypeCamelCase}/${activeModal.riskCategoryCamelCase}`,
                    name: `Datastake ${locationId}/${activeModal.riskTypeCamelCase}/${activeModal.riskCategoryCamelCase}`
                  })
                }}
              >
                {t('View Meassure')}
              </Button>
            ) : (activeModal && (isOwnData || sourceId)) ? (
              <a
                target="_blank"
                href={
                  getLink(
                    `/app/${mod}/view/scl/${locationId}/risk/${activeModal.riskTypeCamelCase}/${activeModal.riskCategoryCamelCase}`
                  )}
                rel="noreferrer"
              >
                <Button type="primary">
                  {t('View Meassure')}
                </Button>
              </a>
            ) : null}
          </>
        ]}
        centered
        width={888}
        onCancel={() => setActiveModal(undefined)}
      >
        <ModalContent
          t={t}
          rec={activeModal}
          layout="LAYOUT_B"
          informationSource={activeModal ? activeModal.proponents[0] : null}
          mode={mode}
          actions={{
            renderObjective,
            renderStatus,
          }}
        />
      </Modal >
      <Table
        sticky
        locale={getLocales(t)}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        className="expandable"
        expandable={expandable}
        rowClassName={(d) => expanded.includes(d.key) ? 'active-row' : ''}
      />
    </>
  );
};

export default TableC;
